import { useEffect, useState } from "react";
import { Button, Form } from "react-bootstrap";
import moment from "moment";

import Select from "react-select";
import CommonGrid from "../../../../components/CommonGrid";
import {
  DateConvert,
  DollarConvert,
  LoadingButton,
  SpinnerBlock,
} from "../../../../Utils/CustomComponent";
import { HeartFill } from "react-bootstrap-icons";
import urls from "../../../../Utils/urls";
import { intialStateRND, reportGridColumn2RND } from "./constantRND";
import classes from "./reports.module.css";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import axios from "../../../../axios";
import { toast } from "react-toastify";
import { commonToast, reportListConverter } from "../../../../Utils";
import CustomBreadCrumbs from "../../../../components/CustomBreadCrumbs";

const OneRunNewReportBorrower = () => {
  const chooseReportLabelListRND = reportListConverter(
    useSelector((state) => state.RS_Authentication.reportList)
  );
  const options = useSelector(
    (state) => state.reportDocument.runNewReport?.options
  );
  const reportName = useSelector(
    (state) => state.reportDocument.runNewReport?.reportName
  );
  const selectSPApi = useSelector(
    (state) => state.reportDocument.runNewReport?.report
  );
  const navigate = useNavigate();
  const [lenderLoan, setLenderLoan] = useState(
    useSelector((state) => state.reportDocument.runNewReport?.option) || []
  );
  const [loading, setLoading] = useState(false);
  const [saveLoading, setSaveLoading] = useState(false);
  const [favourite, setFavourite] = useState(false);
  const [title, setTitle] = useState(null);
  const [errorMsg, setErrorMsg] = useState(null);
  const [reportGridColumn, setReportGridColumn] = useState(null);
  const [columnData, setColumnData] = useState(null);
  const [propState, setPropState] = useState(intialStateRND);
  const userId = localStorage.getItem("apex_userid");
  const userRole = JSON.parse(localStorage.getItem("account")).selectedRole
    .value;
  const accountOptions = useSelector((state) => state.account.accountOptions);

  useEffect(() => {
    if (!reportName) {
      navigate("/run-new-report");
    }
  }, [navigate, reportName]);
  const handleRun = async () => {
    if (selectSPApi?.value) {
      setLoading(true);
      setColumnData(null);
      setErrorMsg(null);
      setTitle(
        chooseReportLabelListRND?.filter(
          (data) => data.value === selectSPApi?.value
        )?.[0]?.label || "label"
      );
      const id = toast.loading("Run New Report Pending");
      try {
        const headers = {
          headers: {
            "Content-Type": "application/json",
          },
        };
        const payload = () => {
          const payObj = {};
          options?.forEach((data) => {
            if (data.type === "date") {
              payObj[data.field] = moment(propState[data.field]).format(
                "DD/MM/yyyy"
              );
            } else {
              payObj[data.field] = propState[data.field];
            }
          });
          return {
            lenderID: lenderLoan?.map((data) => data.value).join(" "),
            ...payObj,
          };
        };

        const res = await axios.post(
          urls.reportsNDocuments.getReports(selectSPApi?.value),
          payload(),
          headers
        );
        toast.update(id, {
          render: "Succesfuly Report Fetched",
          type: "success",
          isLoading: false,
          ...commonToast,
        });

        setReportGridColumn(
          res.data?.[0]?.[0]
            ? Object.keys(res.data[0][0])?.map((data) => {
                let obj = {
                  field: data,
                  title: data,
                };
                if (data?.toLowerCase()?.includes("date")) {
                  obj = {
                    field: data,
                    title: data,
                    Cell: (props) => <DateConvert props={props} />,
                  };
                } else if (
                  data?.toLowerCase()?.includes("amount") ||
                  data?.toLowerCase()?.includes("interest") ||
                  data?.toLowerCase()?.includes("investment") ||
                  data?.toLowerCase()?.includes("payemnt") ||
                  data?.toLowerCase()?.includes("charge") ||
                  data?.toLowerCase()?.includes("fund") ||
                  data?.toLowerCase()?.includes("principal") ||
                  data?.toLowerCase()?.includes("fee") ||
                  data?.toLowerCase()?.includes("other") ||
                  data?.toLowerCase()?.includes("prinbal") ||
                  data?.toLowerCase()?.includes("origbal") ||
                  data?.toLowerCase()?.includes("balance")
                ) {
                  obj = {
                    field: data,
                    title: data,
                    Cell: (props) => <DollarConvert props={props} />,
                  };
                }
                return obj;
              })
            : reportGridColumn2RND
        );
        setColumnData(res.data[0]);
        if (res.data.message === "some error occured") {
          setLoading(false);
          setErrorMsg("some error occured");
          toast.update(id, {
            render: "SOME ERROR OCCURED",
            type: "error",
            isLoading: false,
            ...commonToast,
          });
        }
      } catch (error) {
        console.error(error);
      } finally {
        setTimeout(() => {
          toast.dismiss();
        }, 1000);
      }
    }
  };

  const handleSave = async () => {
    setSaveLoading(true);
    const id = toast.loading("Save New Report Pending");
    try {
      const headers = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      const payload = () => {
        return {
          user_id: userId,
          user_role: userRole,
          report_details: {
            lenderID: lenderLoan,
            report: selectSPApi,
            propState: propState,
            favorite: favourite,
          },
        };
      };
      await axios.post(
        urls.reportsNDocuments.postSaveReport(),
        payload(),
        headers
      );
      setSaveLoading(false);
      toast.update(id, {
        render: "Save New Report Sucess",
        type: "success",
        isLoading: false,
        ...commonToast,
      });
    } catch (error) {
      console.error(error);
      toast.update(id, {
        render: "SOME ERROR OCCURED",
        type: "error",
        isLoading: false,
        ...commonToast,
      });
    } finally {
      setTimeout(() => {
        toast.dismiss();
      }, 1000);
    }
  };

  return (
    <div style={{ overflowY: "scroll" }}>
      <section
        className=" rounded"
        style={{ background: "#eee", minHeight: "92vh" }}
      >
        <CustomBreadCrumbs
          crumbs={[
            { title: "Reports & Documents", link: "/reports-and-documents" },
            { title: "Run New Report", link: "/run-new-report" },
            { title: reportName, link: "" },
          ]}
        />
        <article className="container-fluid">
          <section className="bg-white p-5 my-2 mx-4">
            <Form>
              <Form.Group controlId="formBasicEmail" className="col-sm-6">
                <Form.Label className="mt-5" style={{ fontWeight: "bold" }}>
                  Selected Lenders
                </Form.Label>
                <Select
                  isMulti
                  name="colors"
                  options={[
                    { label: "Select All", value: "all" },
                    ...accountOptions,
                  ]}
                  value={lenderLoan ? lenderLoan : null}
                  onChange={(selected) => {
                    selected?.length &&
                    selected.find((option) => option.value === "all")
                      ? setLenderLoan(accountOptions.slice(0))
                      : setLenderLoan(selected);
                  }}
                  className="basic-multi-select"
                  classNamePrefix="select"
                />
                {/* <Form.Label className="mt-5">Choose Report</Form.Label>
                <Select
                  options={chooseReportLabelListRND?.map(({ value, label }) => ({
                    value,
                    label,
                  }))}
                  value={selectSPApi ? selectSPApi : null}
                  onChange={handleReportChange}
                  classNamePrefix="select"
                /> */}
                {options?.map(
                  (data, index) =>
                    data.display !== "hidden" &&
                    (data.type === "radio" ? (
                      <div key={index}>
                        <Form.Label
                          className="mt-5"
                          style={{ fontWeight: "bold" }}
                        >
                          {data.title}
                        </Form.Label>
                        {data?.options?.map((data2) => (
                          <Form.Check
                            type={data.type}
                            label={data2.title}
                            id={data2.title}
                            checked={propState?.[data.field] === data2.value}
                            onChange={(e) =>
                              setPropState((prevState) => ({
                                ...prevState,
                                [data.field]: data2.value,
                              }))
                            }
                          />
                        ))}
                      </div>
                    ) : (
                      <div key={index}>
                        <Form.Label
                          className="mt-5"
                          style={{ fontWeight: "bold" }}
                        >
                          {data.title}
                        </Form.Label>
                        <Form.Control
                          value={propState?.[data.field]}
                          type={data.type}
                          placeholder=""
                          onChange={(e) =>
                            setPropState((prevState) => ({
                              ...prevState,
                              [data.field]: e.target.value,
                            }))
                          }
                        />
                      </div>
                    ))
                )}
              </Form.Group>
            </Form>
            <Button
              className="mt-5 btn btn-primary text-white btn-outline py-3 px-4 me-3"
              onClick={handleRun}
            >
              Run
            </Button>

            {loading && columnData && (
              <>
                <Button
                  className="mt-5 me-3"
                  onClick={() => setFavourite(true)}
                >
                  <HeartFill style={{ color: favourite ? "red" : "white" }} />
                </Button>
                <LoadingButton
                  loading={saveLoading}
                  onClick={handleSave}
                  className="mt-5 me-3"
                  title={"Save"}
                />
              </>
            )}
            <Button
              className="mt-5"
              onClick={() => navigate("/schedule-report")}
            >
              Schedule Report
            </Button>
            <section className="row d-flex flex-row align-items-stretch justify-content-stretch">
              {loading &&
                (columnData ? (
                  <CommonGrid
                    className={
                      reportGridColumn?.length <= 10
                        ? classes.pastDue15
                        : reportGridColumn?.length <= 20
                        ? classes.pastDue25
                        : classes.pastDue35
                    }
                    title={title}
                    tHeight={"65vh"}
                    gridColumns={reportGridColumn}
                    columnData={columnData ? columnData : null}
                    commonGridData={
                      columnData ? { columnData: columnData } : null
                    }
                  />
                ) : (
                  <SpinnerBlock height={"30vh"} />
                ))}
              <div className="bg-red">{errorMsg}</div>
            </section>
          </section>
        </article>
      </section>
    </div>
  );
};

export default OneRunNewReportBorrower;
